<template style="height:100%">
  <div class="Module_circle">
    <div class="Module_circle_top">
      <h2>圈子管理</h2>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">

        <el-form-item label="圈子名称:">
          <el-input v-model="formInline.Subject" placeholder="圈子名称"></el-input>
        </el-form-item>

        <el-form-item label="创建者:">
          <el-input v-model="formInline.Creator" placeholder="创建者"></el-input>
        </el-form-item>

        <el-form-item label="创建时间:">
          <el-date-picker v-model="formInline.CreateTime" value-format="yyyy-MM-dd"  type="date"  placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-button type="primary" @click="chaxun">查询</el-button>
        <el-button type="primary" @click="chongzhi">重置</el-button>

      </el-form>

    </div>
    <div class="Module_circle_nav" >

      <div class="Module_circle_nav_top">
        <el-button type="primary" @click="addfun()">新增</el-button>
        <el-button type="primary" @click="enablefun(1)">启用</el-button>
        <el-button type="primary" @click="delfun()">删除</el-button>
        <el-button type="primary" @click="enablefun(0)">关闭</el-button>
      </div>

      <el-table ref="multipleTable" v-loading="wloadings"  @selection-change="handleSelectionChange" :row-key="(row) => { return row.circleKey }" :data="tableData" style="width: 98%; margin-top: 10px;margin-left: 1%;" :default-sort="{ prop: 'date', order: 'descending'}">

        <el-table-column type="selection" :selectable="checkSelectable" :reserve-selection="true" width="55"></el-table-column>

        <el-table-column label="序号" width="60px" align="left">
          <template slot-scope="scope">
            {{ (pageIndex - 1) * 10 + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column label="圈子名称">
          <template slot-scope="scope">
            <span>{{ scope.row.circleName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="简介">
          <template slot-scope="scope">
            <span>{{ scope.row.remark }}</span>
          </template>
        </el-table-column>

        <el-table-column label="创建者">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column label="创建时间">
          <template slot-scope="scope">
            <span>{{ scope.row.time }}</span>
          </template>
        </el-table-column>

        <el-table-column label="状态">
          <template slot-scope="scope">
            <span style="color: #3bcb00" v-if="scope.row.status == 1">启用</span>
            <span  v-if="scope.row.status == 0">关闭</span>
          </template>
          <!--<span style="margin-left: 300px;display: inline-block;" v-if="fanxie.counselorAudit == 1">未审核</span>
              <span style="margin-left: 300px;display: inline-block;color: #3bcb00;" v-else-if="fanxie.counselorAudit == 2">审核通过</span>
              <span style="margin-left: 300px;display: inline-block;color: red" v-else-if="fanxie.counselorAudit == 3">审核驳回</span>
              <span style="margin-left: 300px;display: inline-block;color: #3bcb00;" v-else-if="fanxie.counselorAudit == 4">不需要审核</span>
              <span style="width: 40px;height: 40px;text-align: center;border-radius: 50%;background-color: #409EFF;text-align: center;line-height: 40px;display: inline-block;float: right;color: #fff;font-size: 12px;margin-top: -20px;">{{ fanxie.counselorName ? fanxie.counselorName : '无' }}</span> -->
        </el-table-column>

        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button @click="pinglunfanxie(scope.row)" type="text" size="small">查看</el-button>
            <el-button @click="looks(scope.row)" type="text" size="small">修改</el-button>
          </template>
        </el-table-column>

      </el-table>

      <el-pagination style="margin-top: 20px;text-align: right" @current-change="handleCurrentChange" :current-page.sync="pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts"></el-pagination>
    </div>

    <el-dialog :title="tit1" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">

      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

        <el-form-item label="圈子名称" prop="circleName">
          <el-input v-model="ruleForm.circleName" placeholder="请输入圈子名称"></el-input>
        </el-form-item>

        <el-form-item label="圈子简介" prop="remark">
          <el-input type="textarea" v-model="ruleForm.remark" placeholder="请输入圈子简介" maxlength="100" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="圈子类型">
          <el-radio-group v-model="ruleForm.circleType">
            <el-radio label="1">官方圈子</el-radio>
            <el-radio label="2">非官方圈子</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="圈子封面" prop="cover" >
          <div class="cover" style="margin-left:-70px">
            <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" accept="image/jpeg,image/gif,image/png">
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon">
                <span style="font-size: 16px;">点击选择封面</span>
              </i>
            </el-upload>
          </div>
        </el-form-item>

        <el-form-item label="关键词" prop="keyWord">
          <el-input v-model="ruleForm.keyWord" placeholder="请输入关键词"></el-input>
        </el-form-item>

        <el-form-item label="成员别称" prop="nickname">
          <el-input v-model="ruleForm.nickname" placeholder="请输入成员别称"></el-input>
        </el-form-item>

        <el-form-item label="创建目的" prop="objective">
          <el-input v-model="ruleForm.objective" placeholder="请输入创建目的"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="iscontinuous" @click="submitForm('ruleForm')">{{ tit2 }}</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        iscontinuous:false,
        getcircleKey:'',
        tit1:'新增',
        tit2: '立即创建',
        Counts:1,
        imageUrl:"",
        wloadings: true,
        tableData: [],
        circleKey: [],
        dialogVisible: false,
        pageIndex: 1,
        ruleForm: {
          cover: '',
          circleName: '',
          remark: '',
          keyWord: "",
          nickname:'',
          objective: '',
          circleType:'1'
        },
        formInline: {
          CreateTime:'',
          Creator:'',
          Subject:'',
          SubjectTime:'',
          Name: "",
          Student: "",
          ScaleName: "",
          TestTime: "",
          PublishID: "",
          ObjectS: "",
          StudyTime: "",
          Warning: [],
        },
        rules: {
          circleName: [
            { required: true, message: '请输入圈子名称', trigger: 'blur' },
          ],
          remark: [
            { required: true, message: '请输入圈子简介', trigger: 'blur' },
          ],
          keyWord: [
            { required: true, message: '请输入关键词', trigger: 'blur' },
          ],
          nickname: [
            { required: true, message: '请输入成员别称', trigger: 'blur' },
          ],
          objective: [
            { required: true, message: '请输入创建目的', trigger: 'blur' },
          ],
          cover: [
            { required: true, message: '请选择封面', trigger: 'blur' },
          ],
        }
      };
    },
    components:{},
    methods: {
      chaxun(){
        this.loading();
      },
      chongzhi(){
        this.formInline.Subject = '';
        this.formInline.Creator = '';
        this.formInline.CreateTime = '';
        this.pageIndex = 1;
        this.loading();
      },
      pinglunfanxie(a){
        let routeData = this.$router.resolve({
          path: '/Activity/Module_circle_details',
          query: { circleKey: a.circleKey },
        })
        this.$router.push(routeData.href);
      },
      looks(row) {
        this.getcircleKey = row.circleKey;
        var from = {circleKey: row.circleKey}

        this.$Http_Post('/activitymanagement/fxcircle', { from: from }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.dialogVisible = true;
            this.tit1 = "修改";
            this.tit2 = "立即修改";
            this.imageUrl = res.Data.cover;

            this.ruleForm = {
              cover: res.Data.cover,
              circleName: res.Data.circleName,
              remark: res.Data.remark,
              keyWord: res.Data.keyWord,
              nickname: res.Data.nickname,
              objective: res.Data.objective,
              circleType: (res.Data.circleType).toString()
            }

          } else {
            this.Global.request_failure(res.Message);
          }
        })

      },
      addfun() {
        this.tit1 = "新增";
        this.dialogVisible = true;
        this.ruleForm = {
          cover: '',
          circleName: '',
          remark: '',
          keyWord: "",
          nickname: '',
          objective: '',
          circleType: '1'
        }
      },
      delfun() {
        if(!this.circleKey.length>0){
          alert('请选择选项!')
          return false
        }
        var from = {circleKeys: this.circleKey}
        this.$Http_Post('/activitymanagement/decircle', { from: from }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.circleKey = []
            this.$refs.multipleTable.clearSelection();
            this.loading();
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      },
      enablefun(status) {
        if(!this.circleKey.length>0){
          alert('请选择选项!')
          return false
        }
        var from = {
          circleKeys: this.circleKey,
          status: status
        }
        this.$Http_Post('/activitymanagement/qgcircle', {from: from}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.circleKey = []
            this.$refs.multipleTable.clearSelection();
            this.loading();
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.iscontinuous = true;
            if (this.tit2 == '立即创建') {
              var from = new FormData();
              from.append('circleName', this.ruleForm.circleName);
              from.append('circleType', this.ruleForm.circleType);
              from.append('remark', this.ruleForm.remark);
              from.append('keyWord', this.ruleForm.keyWord);
              from.append('nickname', this.ruleForm.nickname);
              from.append('objective', this.ruleForm.objective);
              from.append('cover', this.ruleForm.cover.raw);
              this.$Http_Post('/activitymanagement/addcircle', from, {}).then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                  this.iscontinuous = false
                  this.Global.request_successful(res.Message);
                  this.dialogVisible = false;
                  this.Counts = res.Counts;
                  this.ruleForm = {
                    cover: '',
                    circleName: '',
                    remark: '',
                    keyWord: "",
                    nickname: '',
                    objective: '',
                    circleType: '1'
                  }
                  this.loading();
                } else {
                  this.iscontinuous = false
                  this.Global.request_failure(res.Message);
                }
              })
            } else {
              var from = new FormData();
              from.append('circleName', this.ruleForm.circleName);
              from.append('circleType', this.ruleForm.circleType);
              from.append('remark', this.ruleForm.remark);
              from.append('keyWord', this.ruleForm.keyWord);
              from.append('nickname', this.ruleForm.nickname);
              from.append('objective', this.ruleForm.objective);
              from.append('circleKey', this.getcircleKey);
              from.append('cover', this.ruleForm.cover.raw);
              this.$Http_Post('/activitymanagement/upcircle', from, {}).then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                  this.iscontinuous = false
                  this.Global.request_successful(res.Message);
                  this.dialogVisible = false;
                  this.ruleForm = {
                    cover: '',
                    circleName: '',
                    remark: '',
                    keyWord: "",
                    nickname: '',
                    objective: '',
                    circleType: '1'
                  }
                  this.loading();
                } else {
                  this.iscontinuous = false
                  this.Global.request_failure(res.Message);
                }
              })
            }
          } else {
            console.log('error submit!');
            return false;
          }
        });
      },
      handleCurrentChange(val) {
        this.pageIndex = val;
        this.wloadings = true;
        this.loading();
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 8
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isLt2M;
      },
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      handleChange(file) {
        if(file.raw.type == "image/jpeg" || file.raw.type == "image/gif" || file.raw.type == "image/png"){
          this.imageUrl = URL.createObjectURL(file.raw);
          this.ruleForm.cover = file;
        }else{
          this.$message({
            type: 'error',
            message: "文件格式错误，请上传图片",
          })
        }
      },
      handleClose(done) {
        this.$confirm('确认关闭？').then(_ => {
          done();
        })
        .catch(_ => {});
      },
      checkSelectable(row) {
        if (row.IsSubmit == "已生成报告") {
          return true;
        } else {
          return true;
        }
      },

      handleSelectionChange(val) {
        var lsc = [];
        for (var i = 0; i < val.length; i++) {
          lsc.push(val[i].circleKey);
        }
        this.circleKey = lsc;
      },

      loading() {
        var from = {
          pageSize: "10",
          pageIndex: this.pageIndex,
          circleName: this.formInline.Subject,
          creator: this.formInline.Creator,
          createTime: this.formInline.CreateTime,
        }

        this.$Http_Post("/activitymanagement/getcircles",{from:from}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.tableData = res.Data;
            this.Counts = Number(res.Counts);
            this.wloadings = false;
          } else {
            this.wloadings = false;
          }
        })

      },
    },
    mounted(){
      this.loading();
    }
  };
</script>
<style>
.Module_circle .Module_circle_top {height: 152px;width: 100%;background-color: #fff;}
.Module_circle .Module_circle_top .el-form{margin-left: 20px;}
.Module_circle .Module_circle_top h2{width: 98%;height: 50px;line-height: 50px;margin-left: 16px;font-size: 18px;}
.Module_circle .Module_circle_top .Module_circle_div{height: 30px;margin-top: 16px;}
.Module_circle .Module_circle_top .Module_circle_div span{width: 80px;margin-left: 16px;float: left;}
.Module_circle .Module_circle_top .Module_circle_div ul{display: inline-block;float: left;margin-left: -20px;}
.Module_circle .Module_circle_top .Module_circle_div li{float: left;margin-left: 20px;}
.Module_management_nav{background-color: #fff;margin-top: 16px;height: calc(100% - 180px);}
.Module_circle_nav{background-color: #fff;margin-top: 16px;height: calc(100% - 180px);overflow: auto;}
.Module_circle .Module_circle_nav_top{padding-top: 16px;margin-left: 16px;}
.Module_circle .Module_circle_nav_top{padding-top: 16px;margin-left: 16px;}
.Module_circle .el-form-item__content {width: 50%;}
.Module_circle .cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 297px;width: 350px;}
.Module_circle .avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;position: relative;margin-left: 0px;overflow: hidden;}
.Module_circle  .avatar-uploader .el-upload:hover {border-color: #409eff;}
.Module_circle  .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
.avatar {width: 215px;height: 148px;display: block;}
.Module_circle .el-table td, .el-table th{text-align: center;}
.Module_circle .Module_circle_top .el-form-item__content {width: 66%;}
.Module_circle{height: 100%;}
</style>